import React from "react";
import Achievements from "./Achievements";
import Education from "./Education";
import Experience from "./Experience";
import PersonalInfo from "./PersonalInfo";
import Skills from "./Skills";
import Certifications from "./Certifications";
import cv from "../../assets/img/ajesh-resume.pdf";

const Index = () => {
  return (
    <section className="main-content">
      <div className="container">
        <div className="row">
          {/* About the content Starts */}
          <div className="col-12 col-lg-5 col-xl-6">
            <div className="row">
              <div className="col-12">
                <h3 className="text-uppercase custom-title ft-wt-600 pb-3">
                  personal Info
                </h3>
              </div>
              {/* End .col */}

              <PersonalInfo />
              {/* End personal info */}

              <div className="col-12 mt-3">
                <a className="button" href={cv} download>
                  <span className="button-text">Download CV</span>
                  <span className="button-icon fa fa-download"></span>
                </a>
              </div>
              {/* End download button */}
            </div>
          </div>
          {/*  Personal Info Ends */}

          {/*  Boxes Starts */}
          <div className="col-xl-6 col-lg-7 col-12 mt-5 mt-lg-0">
            <Achievements />
          </div>
          {/* Achievements Ends */}
        </div>
        {/* End .row */}

        <hr className="separator" />

        {/* Skills Starts */}
        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-4 pb-sm-5 mb-3 mb-sm-0 text-left text-sm-center custom-title ft-wt-600">
              My Skills
            </h3>
          </div>
          <Skills />
        </div>
        {/* Skills Ends */}

        <hr className="separator mt-5" />

        {/* Certifications Starts */}
        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-3 mb-3 text-left text-sm-center custom-title ft-wt-600">
              Certifications & Badges
            </h3>
          </div>
          <div className="col-12">
            <Certifications />
          </div>
        </div>
        {/* Certifications Ends */}

        <hr className="separator mt-4" />

        {/* Experience & Education Starts */}
        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-5 mb-0 text-left text-sm-center custom-title ft-wt-600">
              Experience <span>&</span> Education
            </h3>
          </div>
          <div className="col-lg-6 m-15px-tb">
            <div className="resume-box">
              <Experience />
            </div>
          </div>
          <div className="col-lg-6 m-15px-tb">
            <div className="resume-box">
              <Education />
            </div>
          </div>
        </div>
        {/* Experience & Education Ends */}
      </div>
    </section>
  );
};

export default Index;
